import {Component, inject, OnInit, signal} from '@angular/core';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {PointEmailDto} from "../../../../../generated-model/model";
import {from} from "rxjs";
import {filter} from "rxjs/operators";
import {PointEmailResource} from "../../../../service/PointEmailResource";
import {NgForOf} from "@angular/common";
import {NotFoundComponent} from "../../../../shared/not-found/not-found.component";
import {ManageEmailPointModalComponent} from "./manage-email-point-modal/manage-email-point-modal.component";
import {FormsModule} from "@angular/forms";
import {ToastService} from "../../../../shared/commons/toast/toast-service";
import {GroupEmailType} from "../../../../app.constants";

@Component({
  selector: 'app-manage-email-point',
  standalone: true,
  imports: [
    NgForOf,
    NotFoundComponent,
    FormsModule,
  ],
  templateUrl: './manage-email-point.component.html',
  styleUrl: './manage-email-point.component.scss'
})
export class ManageEmailPointComponent implements OnInit {
  modalService = inject(NgbModal);
  pointEmailResource = inject(PointEmailResource);
  selectGroupEmail = signal<GroupEmailType>('ALL');
  items: PointEmailDto[] = [];
  toastService = inject(ToastService);
  ngOnInit(): void {
    this.search()
  }

  search() {
    this.pointEmailResource.findAllEmail().subscribe(e => {
      this.items = e;
      this.updateGroupSelection()
    });
  }

  manageEmailModal(item: PointEmailDto) {
    const modalRef = this.modalService.open(ManageEmailPointModalComponent, {
      size: "xl",
      windowClass: 'custom-modal-content',
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.item = item;
    from(modalRef.result).pipe(filter(e => !!e))
      .subscribe(e => {
        this.search()
      });
  }

  update(){
    this.pointEmailResource.update(this.selectGroupEmail()).subscribe(e => {
      this.toastService.showSuccess('บันทึกสำเร็จ');
    })
  }

  private updateGroupSelection() {
    const allZones = this.items.every(item =>
      item.emails?.every(email => email.send)
    );

    const zoneOnly = this.items.every(item => {
      if (item.code === '15') {
        return item.emails?.every(email => !email.send);
      }
      return item.code >= '01' && item.code <= '13' &&
        item.emails?.every(email => email.send);
    });

    const nhsoOnly = this.items.every(item => {
      if (item.code === '15') {
        return item.emails?.every(email => email.send);
      }
      return item.code >= '01' && item.code <= '13' &&
        item.emails?.every(email => !email.send);
    });

    if (allZones) {
      this.selectGroupEmail.set('ALL');
    } else if (zoneOnly) {
      this.selectGroupEmail.set('ZONE');
    } else if (nhsoOnly) {
      this.selectGroupEmail.set('NHSO');
    }
  }

}
